import { render, staticRenderFns } from "./tptj.vue?vue&type=template&id=6e73a2be"
import script from "./tptj.vue?vue&type=script&lang=js"
export * from "./tptj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports